var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',[_c('v-autocomplete',{attrs:{"rules":[_vm.required],"loading":!_vm.locations.length,"items":_vm.locations,"item-value":"location_guid","item-text":"name","outlined":"","label":"Kategorier","multiple":"","disabled":_vm.readonly},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }